
import axios from 'axios';

export const login = (auth) => ({
  type: 'LOGIN',
  auth
});

export const startLogin = (values) => {
 
 return(dispatch, getState) => {
  //console.log('startLogin values', values)
    axios.defaults.baseURL = process.env.AUTH_SERVER || "https://geografia-user-admin.herokuapp.com";
    axios.get("/api/spendmapp_user.json", {
        auth: {
          username: values.userName,
          password: values.password
        }
      })
      .then(response => {
        //console.log('response', response)
        const auth = {
          isLoggedin: true,
          message: response.data,
          code: response.status,

        }
        dispatch(login(auth));
        dispatch(push('/economicmodeldashboard'))
      })
      .catch(error => {
        if(error !== undefined) {
          //console.log('error', error.response)
          const auth = {
            isLoggedin: false,
            message: error.response.data,
            code: error.response.status,
          }
          dispatch(login(auth));
        }

      });
  };
}

// SET Profile
export const logout = (newState = {}) => ({
  type: 'LOGOUT',
  newState
})

export const startLogout = () => {
  const newState = {
    isLoggedin: false
  }
  return(dispatch, getState) => {
      return dispatch(logout(newState));
  }
};



// WEBPACK FOOTER //
// ./src/actions/auth.js